export default "__VITE_ASSET__Bml9jkAH__"